export default __webpack_public_path__ + "static/media/kvitanciya3.f2b40ca1.xls";